import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full flex flex-col space-y-5" }
const _hoisted_2 = { class: "w-full flex flex-row items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Users List ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row space-x-2" }, null, -1)
const _hoisted_5 = { class: "col-span-full w-full flex flex-col space-y-2 rounded-md border-[1px] border-grey300 px-4 py-4" }
const _hoisted_6 = { class: "w-full flex flex-col py-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_roof_header_text = _resolveComponent("roof-header-text")!
  const _component_roof_table = _resolveComponent("roof-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_roof_header_text, { size: "xl" }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_roof_table, {
          tableStructure: _ctx.Logic.Users.UserTableStructure,
          paginatedData: _ctx.userList,
          "table-date-source": _ctx.Logic.Users.UserSource,
          "sub-page-route": '/users/'
        }, null, 8, ["tableStructure", "paginatedData", "table-date-source"])
      ])
    ])
  ]))
}